export default __webpack_public_path__ + "static/media/icons8-graphql.255f0aab.svg";